import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const contentReflowSiteConfig: SiteConfigFn<Record<string, never>> = ({ api }) => {
	const isDesktop = api.env.getViewMode() === 'desktop'
	const isResponsive = !!api.rendererModel.getSiteMetaData()?.isResponsive
	const isExperimentOpen = !!api.env.getExperiments()?.['specs.thunderbolt.showContentReflowBanner']

	return {
		shouldLoadSiteFeature: isDesktop && !isResponsive && isExperimentOpen,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'contentReflow'

export const config = { site: contentReflowSiteConfig, name }
